import React from 'react';
import styled from 'styled-components';
import { COLORS, device } from '../../../../constants';
import { MotionProjectStore } from '../../../../components/Motion';

interface LinkProps extends React.HTMLProps<HTMLAnchorElement> {
  img: React.FC;
  subtitle: string;
  title: string;
  link: string;
}

export const StoreCard: React.FC<LinkProps> = ({
  img: Icon,
  subtitle,
  title,
  link,
  ...props
}) => {
  return (
    <CardStyle
      {...props}
      href={link}
      target="_blank"
    >
      <StoreIcon>
        <Icon />
      </StoreIcon>
      <StoreText>
        <StoreSubtitle>{subtitle}</StoreSubtitle>
        <StoreTitle>{title}</StoreTitle>
      </StoreText>
    </CardStyle>
  );
};

const CardStyle = styled(MotionProjectStore)`
  text-decoration: none;
  color: ${COLORS.BLACK_SUBTITLE};
  box-sizing: border-box;
  height: 70px;
  border-radius: 10px;
  border: 0.5px solid ${COLORS.BLACK_SUBTITLE};
  padding: 14px 30px;
  display: flex;
  gap: 12px;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background-color: #b8b8b830;
  }
  @media screen and ${device.lg} {
    padding: 10px;
    height: auto;
    gap: 8px;
    flex: 0 0 auto;
  }
  @media screen and ${device.sm} {
    padding: 5px;
    height: auto;
    gap: 4px;
    border-radius: 8px;
  }
`;

const StoreIcon = styled.div`
  color: ${COLORS.BLACK_SUBTITLE};
  @media screen and ${device.lg} {
    width: 30px;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  @media screen and ${device.sm} {
    width: 10px;
  }
`;

const StoreText = styled.div`
  width: 115px;
  @media screen and ${device.lg} {
    width: auto;
  }
`;
const StoreSubtitle = styled.p`
  margin: 0 0 6px 0;
  font-size: 12px;
  @media screen and ${device.sm} {
    margin-bottom: 4px;
    font-size: 8px;
  }
`;
const StoreTitle = styled.p`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  text-wrap: nowrap;
  @media screen and ${device.lg} {
    font-size: 16px;
  }
  @media screen and ${device.md} {
    font-size: 13px;
  }
  @media screen and ${device.sm} {
    font-size: 10px;
  }
`;
